module.exports = __webpack_public_path__ + "img/free_multiplier_4.b938c9b1.png";